import * as React from "react";
import { Viewport, ViewSmall, ViewMedium } from "bernie-view";
import { UitkSpacing } from "uitk-react-spacing";

import { TripsImportant } from "@shared-ui/trips-lists";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";

import { Experiment as Experiments, isVariantEnabled } from "src/components/utility/experiment";
import { TripsBexApiComponentProps } from "components/shared/BexApiWrapper/TripsBexApiWrapper";

export const TripsOverviewImportant = ({ inputs: { flexContext } }: TripsBexApiComponentProps) => {
  const { SDUI_Trips_Total_Throttle, PWA_Trips_Important_SF, Trips_PWA_SDUI_Rollout } = Experiments;

  const isTripsExperimentEnabled = isVariantEnabled(flexContext, PWA_Trips_Important_SF);

  if (!isTripsExperimentEnabled) {
    return null;
  }

  return (
    <Experiment name={SDUI_Trips_Total_Throttle}>
      <ExperimentControl />
      <ExperimentVariant bucket={1}>
        <Experiment name={Trips_PWA_SDUI_Rollout}>
          <ExperimentControl />
          <ExperimentVariant bucket={1}>
            <div className="TripsOverviewImportant" data-testid="trips-overview-important">
              <Viewport>
                <ViewSmall>
                  <UitkSpacing padding={{ block: "three" }}>
                    <div>
                      <TripsImportant />
                    </div>
                  </UitkSpacing>
                </ViewSmall>
                <ViewMedium />
              </Viewport>
            </div>
          </ExperimentVariant>
        </Experiment>
      </ExperimentVariant>
    </Experiment>
  );
};

export default TripsOverviewImportant;
